import { Component, OnInit } from '@angular/core';
import {AllCommunityModules} from '@ag-grid-community/all-modules';
// import {AllModules} from '@ag-grid-enterprise/all-modules';
import { HttpClient } from '@angular/common/http';
import '@ag-grid-community/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-community/all-modules/dist/styles/ag-theme-balham.css';
import {environment} from '../../environments/environment';
import {Subscription} from 'rxjs';
import { DownloadFileCellRenderer} from "./download-file-cell-renderer";

@Component({
  selector: 'app-healthcare-liability',
  templateUrl: './healthcare-liability.component.html',
  styleUrls: ['./healthcare-liability.component.scss']
})
export class HealthcareLiabilityComponent implements OnInit {
    defaultColumDefs = {
      resizable: true,
      sortable: true,
      filter: true
    };

    columnDefs = [
      {headerName: 'CMSID', field: 'cmsid', maxWidth: 110},
      {headerName: 'Facility Name', field: 'facility', width: 200},
      {headerName: 'Address', field: 'address', width: 200},
      {headerName: 'State', field: 'state', maxWidth: 90},
      {headerName: 'City', field: 'city', maxWidth: 150},
      {headerName: 'ZIP', field: 'zip', maxWidth: 100},
      {headerName: ' ', field: 'file', sortable: false, filter: false, maxWidth: 50,
          cellRenderer: 'downloadFileCellRenderer'
      }
    ];
    frameworkComponents = {
      downloadFileCellRenderer: DownloadFileCellRenderer
    };
    rowData: any;
    gridApi: any;
    gridColumnApi: any;
    fetchSubscription: Subscription;

    // modules = AllModules;
    modules = AllCommunityModules;

  constructor(private http: HttpClient) {}

  ngOnInit() {
  }

  onGridReady(event) {
    this.gridApi = event.api;
    this.gridColumnApi = event.columnApi;
    this.gridApi.sizeColumnsToFit();

    const url = window.location.origin + '/api/plsnapshot/get-providers';
    this.fetchSubscription = this.http.get(url).subscribe((data: any[]) => {
      this.rowData = data;
    });
  }
}
